var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGreaterThanOrEqualTo = function SvgGreaterThanOrEqualTo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "greater than or equal to",
    d: "M1.5 1.85 2.13 0 12.5 4.39v1.92L2.13 10.7 1.5 8.86 10 5.35Zm0 10.25h11V14h-11Z"
  })));
};

export default SvgGreaterThanOrEqualTo;